module.exports = __webpack_public_path__ + "static/media/regagri.b182b356.png";